import { useEffect, useState } from "react";

export function useTooltipEtiqueta(arrayEtiquetasLength) {
    const [tooltip, tooltipSet] = useState("Selecione uma linha da tabela para seguir com a ação");
    const [isDownloadButtonDisabled, setIsDownloadButtonDisabled] = useState(true);
    
    useEffect(() => {
        if(arrayEtiquetasLength >= 50){
            setIsDownloadButtonDisabled(true);
            return tooltipSet("Selecione no máximo 50 produtos para fazer o download da etiqueta"); 
        }
        if(arrayEtiquetasLength > 0){
            setIsDownloadButtonDisabled(false);
            return tooltipSet("");
        }
        else {
            setIsDownloadButtonDisabled(true);
            return tooltipSet("Selecione uma linha da tabela para seguir com a ação");
        }
    }, [arrayEtiquetasLength]);

    return { tooltip, isDownloadButtonDisabled };
}
